import { render, staticRenderFns } from "./Lgx368736922169769984.vue?vue&type=template&id=3ca67ccd&scoped=true&"
import script from "./Lgx368736922169769984.vue?vue&type=script&lang=js&"
export * from "./Lgx368736922169769984.vue?vue&type=script&lang=js&"
import style0 from "./Lgx368736922169769984.vue?vue&type=style&index=0&id=3ca67ccd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca67ccd",
  null
  
)

export default component.exports